export enum ROOM_TYPE_IDS {
  WAITING_ROOM = 5,
}
